// Turnstile site key
const TURNSTILE_SITE_KEY = '0x4AAAAAAA2-9XoW5gLykbnw';

let turnstileWidgetId = null;
let renderAttempts = 0;
const MAX_ATTEMPTS = 3;

// Function to validate token with Cloudflare
export async function validateTurnstileToken(token) {
  try {
    const response = await fetch(
      'https://r7ej0e9i28.execute-api.ap-southeast-2.amazonaws.com/dev/validateturnstile',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token }),
      }
    );

    if (!response.ok) {
      throw new Error(`Turnstile validation failed: ${response.status}`);
    }

    const data = await response.json();
    return data.success === true;
  } catch (error) {
    console.error('Turnstile validation error:', error);
    return false;
  }
}

// Function to render Turnstile widget
export const renderTurnstile = (callback) => {
  if (!window.turnstile) {
    console.error('Turnstile not loaded');
    return;
  }

  // Reset attempts counter when explicitly called to render
  renderAttempts = 0;

  try {
    // Clean up existing widget if any
    if (turnstileWidgetId) {
      window.turnstile.remove(turnstileWidgetId);
      turnstileWidgetId = null;
    }

    const element = document.getElementById('turnstile-widget');
    if (!element) {
      console.warn('Turnstile widget element not found');
      return;
    }

    // At the start of renderTurnstile
    // Create new widget
    turnstileWidgetId = window.turnstile.render('#turnstile-widget', {
      sitekey: TURNSTILE_SITE_KEY,
      callback: (token) => {
        if (callback) callback(token);
      },
      'refresh-expired': 'manual',
      'retry-interval': '10000',
      'execution-environment': 'render-amd',
      'appearance': 'always',
      'size': 'normal',
      'touchscreen': true,
      'error-callback': (error) => {
        console.warn('Turnstile error:', error, {
          hostname: window.location.hostname,
          host: window.location.host,
          userAgent: window.navigator.userAgent,
          isTouchDevice: 'ontouchstart' in window
        });
        if (renderAttempts < MAX_ATTEMPTS) {
          renderAttempts++;
          setTimeout(() => resetTurnstile(), 1000);
        }
      }
    });
  } catch (error) {
    console.error('Error rendering Turnstile:', error);
  }
};

// Function to reset Turnstile widget
export const resetTurnstile = async () => {
  if (!window.turnstile || !turnstileWidgetId || renderAttempts >= MAX_ATTEMPTS) {
    return;
  }

  try {
    window.turnstile.remove(turnstileWidgetId);
    turnstileWidgetId = null;
    await new Promise(resolve => setTimeout(resolve, 1000));
    renderTurnstile();
  } catch (error) {
    console.error('Error resetting Turnstile:', error);
  }
};

// Cleanup function
export const cleanupTurnstile = () => {
  if (window.turnstile && turnstileWidgetId) {
    try {
      window.turnstile.remove(turnstileWidgetId);
      turnstileWidgetId = null;
      renderAttempts = 0;
    } catch (error) {
      console.error('Error cleaning up Turnstile:', error);
    }
  }
};